import React from 'react'

import Page from '../../../components/pdf/Page'
import QrcodesGrid from './qrcodes/QrcodesGrid'

const PdfDocument = () => {
  return (
    <Page>
      <QrcodesGrid />
    </Page>
  )
}

export default PdfDocument
